document.addEventListener('DOMContentLoaded', function () {
  var sidebar = document.getElementById('enova-distributor-sidebar');
  if (!sidebar) return;

  var openers = document.querySelectorAll('[data-enova-open-distributor]');
  var closers = sidebar.querySelectorAll('[data-enova-close-distributor]');

  function openSidebar(e) {
    if (e) e.preventDefault();
    sidebar.classList.add('is-open');
    document.documentElement.classList.add('enova-distributor-open');
  }

  function closeSidebar(e) {
    if (e) e.preventDefault();
    sidebar.classList.remove('is-open');
    document.documentElement.classList.remove('enova-distributor-open');
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', openSidebar);
  });

  closers.forEach(function (btn) {
    btn.addEventListener('click', closeSidebar);
  });

  // Cerrar con ESC
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      closeSidebar();
    }
  });
});